import React, { useContext } from 'react';
import { Modal } from 'flowbite-react';
import ModalGreenButton from './ModalGreenButton';
import DocumentItem from './DocumentItem';
import Loading from './Loading';

import MyProceduresContext from '../context/ProceduresContext';
import MyRequirementsContext from '../context/RequirementsContext';

const ModalProcedures = ({ isModalProceduresOpen, setIsModalProceduresOpen }) => {
    const { procedure, getFile, error, loading } = useContext(MyProceduresContext);
    const { useRequirements } = useContext(MyRequirementsContext);
    const { requirements, isError, isLoading } = useRequirements();
    return (
        <Modal show={isModalProceduresOpen} position="top-center" style={{ display: 'flex', alignItems: 'center' }}>
            <div className='flex flex-col p-8 modal relative' style={{ maxHeight: '95vh', overflowY: 'scroll', width: '100%' }}>
                <div className='flex justify-between mb-3 items-center'>
                    <div className='text-xl font-mono uppercase text-center w-full'>
                        {procedure.procedureTitle}
                    </div>
                    <button onClick={() => setIsModalProceduresOpen(false)} className='pb-5 ml-3'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" className="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className='font-light text-justify break-words mb-3'>
                    {procedure.procedureDescription.split('\r\n').map((item, i) => {
                        return <span key={i}>{item}<br /></span>
                    })}
                </div>
                <div className='flex flex-row mb-3'>
                    <h1 className='pr-2 font-mono'>
                        Tipo de {procedure.procedureTypeId == 1 ? "Trámite: " : "Producto: "}
                    </h1>
                    <h1 className='font-light'>{procedure.procedureClassName}</h1>
                </div>
                <div className='flex flex-col mb-3'>
                    <span className='pb-2 font-mono'>
                        Documentos necesarios:
                    </span>

                    <Loading isLoading={isLoading} />

                    {requirements ? requirements.length > 0 ? requirements.map((requirement, index) => (
                        <DocumentItem key={index} requirement={requirement} />
                    )) : <h1 className='font-light my-1'>Este trámite no tiene documentos asignados</h1> : null
                    }
                    {isError ? <h1 className='text-center text-red-500 w-full mb-4'>Ha ocurrido un error al cargar los datos.</h1> : null}

                </div>
                {loading ? <Loading isLoading={true} /> : <button onClick={() => { getFile(procedure.procedureFilePath, procedure.procedureTypeId == 1 ? "Tramite" : "Producto") }} className='flex flex-col mb-3 mx-auto'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-14 h-14 mx-auto">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                    </svg>

                    <span className='pb-2'>
                        Descargar
                    </span>

                </button>}
                {error.error ? <h1 className='text-center text-red-500 w-full mb-4'>{error.message}</h1> : null}
                <div className='w-[40%] mx-auto'>
                    <ModalGreenButton onClick={() => setIsModalProceduresOpen(false)} text='Aceptar' />
                </div>
            </div>
        </Modal>
    );
}

export default ModalProcedures;